import { useEffect, useState } from 'react';
import axios from 'axios';
import { extractErrorMessage } from '../utils/apiErrors';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const hasEquipmentSite = (site) => !!([site?.name, site?.lsd, site?.address, ...Object.values(site?.components || {})].some((v) => String(v || '').trim()));

export const useEquipmentHistory = (open, customerId, site) => {
  const filtered = hasEquipmentSite(site);
  const query = JSON.stringify({ customer_id: customerId || '', site_filter: filtered,
    site_name: site?.name || '', site_lsd: site?.lsd || '', site_address: site?.address || '' });
  const [result, setResult] = useState({}), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!open) return;
    const controller = new AbortController();
    setResult({ query, loading: true, rows: [] });
    axios.get(`${API}/equipment-history`, { params: JSON.parse(query), signal: controller.signal })
      .then((r) => { if (!controller.signal.aborted) setResult({ query, rows: r.data.equipment || [] }); })
      .catch((e) => { if (!controller.signal.aborted) setResult({ query, rows: [], error: extractErrorMessage(e, 'Unable to load past customer assets') }); });
    return () => controller.abort();
  }, [open, query, attempt]);
  const current = result.query === query ? result : { loading: true, rows: [] };
  return { ...current, filtered, retry: () => setAttempt((n) => n + 1) };
};